import { createMetaInfoObject } from '~/lib'

interface MetaTags {
  [key: string]: string
}

type MetaTagEntry = { key?: string | null; value?: unknown }
type EntityWithMeta = { __typename?: string; entityMetatags?: Array<MetaTagEntry | null> | null }

export const useDrupalMetaTags = (entityInput?: EntityWithMeta | null | false) => {
  const entity = entityInput && typeof entityInput === 'object' ? (entityInput as EntityWithMeta) : null
  const isIndexable =
    entity?.__typename === 'NodeProtectedPage' || entity?.__typename === 'NodeCbzLandingPage' ? false : true

  const tags: MetaTags = {}
  if (entity?.entityMetatags) {
    entity.entityMetatags.forEach((tag) => {
      if (!tag) return
      if (typeof tag.value === 'string' && typeof tag.key === 'string') {
        tags[tag.key] = tag.value
      }
    })
  }

  useSeoMeta(
    createMetaInfoObject([
      ['title', tags['title'] || undefined],
      ['description', tags['description'] || undefined],
      ['keywords', tags['keywords'] || undefined],
      ['image_src', tags['image_src'] || undefined],
      ['og:title', tags['og:title'] || undefined],
      ['og:description', tags['og:description'] || undefined],
      ['og:image', tags['og:image'] || undefined],
      ['og:site_name', tags['og:site_name'] || undefined],
      ['og:url', tags['canonical'] || undefined],
      ['canonical', tags['canonical'] || undefined],
      ['content-language', tags['content-language'] || undefined],
      ['robots', !isIndexable ? 'noindex, nofollow, noimageindex' : tags['robots'] || undefined],
    ]),
  )

  const config = useRuntimeConfig()

  // Add alternate links.
  const alternateLinks = entity?.entityMetatags
    ? entity.entityMetatags
        .filter((tag): tag is MetaTagEntry => Boolean(tag))
        .filter((tag) => tag.key === 'alternate')
        .map((tag) => {
          const v = tag.value as { rel: 'alternate'; hreflang: string; href: string }
          return {
            rel: v.rel,
            hreflang: v.hreflang,
            href: `${config.public.frontendBaseUrl}${v.href}`,
          }
        })
    : []
  useHead({
    link: alternateLinks,
  })
}
